import React, { PureComponent } from 'react'
import classnames from 'classnames'
import BaseIcon from './BaseIcon'

const IonIcon = props => {
  return <BaseIcon {...props} family="ionicon" />
}

export default IonIcon
